import { useEffect, useState } from "react";
import { selectEntryChannelsLoadingPag, selectEntryChannelsPag } from "../../redux/entryChannels/selectors";
import { AdminTable } from "./AdminTable";
import { useDispatch, useSelector } from "react-redux";
import { Column } from "devextreme-react/data-grid";
import { createEntryChannel, deleteEntryChannel, editEntryChannel, getEntryChannelsPag } from "../../redux/entryChannels/thunks";
import { openModal } from "../../redux/modal/modalSlice";


const initialSortOptions = {
    columna: "entryChannelId",
    sortOrderAsc: true

}

function EntryChannelManagement() {
    const entrychannels = useSelector(selectEntryChannelsPag);
    const dispatch = useDispatch();
    const loading = useSelector(selectEntryChannelsLoadingPag);
    const [sortOptions, setSortOptions] = useState(initialSortOptions)
    

    useEffect(()=>{
        getListEntryChannels(mapPageInfo(entrychannels));
    }, [])

    function mapPageInfo(entrychannelsData){
        return {
            pageIndex: entrychannelsData.pageIndex ?? 0,
            pageSize: entrychannelsData.pageSize ?? 10,
            orderByField:  entrychannelsData.columna ?? "entryChannelId",
            orderByAscending:  entrychannelsData.sortOrderAsc ?? true
        }
    }
      
    const getListEntryChannels = (pageInfo) => {
        let query = `?pageIndex=${pageInfo.pageIndex}&pageNum=${pageInfo.pageSize}`
        if(pageInfo.searchString?.trim().length > 0){
            query = query.concat(`&searchString=${pageInfo.searchString.trim()}`)
        }
        if(pageInfo.orderByField)
            {
                query = query.concat(`&orderByField=${pageInfo.orderByField}&orderByAscending=${pageInfo.orderByAscending}`)
            }
        dispatch(getEntryChannelsPag({query}));
    }

    const columnsEntryChannels = [
        <Column sortIndex={1} key={"entrychannel-1"} dataField="code" caption="Código" allowEditing={false} allowCreating={false}/>, 
        <Column key={"entrychannel-2"} dataField="description" caption="Descrição" />, 
    ] 

    function handleSaveNewEntryChannelClick(value, closeCreateModal) {   
        const entryChannelDescription = value.description.trim();    
        if(entryChannelDescription){
            const entryChannelDescriptionExists = entrychannels.elements.some(entryChannel => entryChannel.description.toLowerCase() === entryChannelDescription.toLowerCase());
            if(entryChannelDescriptionExists)
                dispatch(openModal({ type: "warning", message:"A descrição inserida já existe."}))
            else{
                const entryChannelParams ={body:{
                    description: entryChannelDescription}
                }
                dispatch(createEntryChannel(entryChannelParams)).then((data) => {
                    if(data.error)
                        dispatch(openModal({ type: "warning", message:data.error.message}))
                    else{
                        getListEntryChannels(mapPageInfo({...entrychannels, ...sortOptions}));
                        closeCreateModal();
                    }                    
                })
            }            
        }else{
           closeCreateModal()
        }       
    }    

    const handleEditClick = (value, closeEditModal) => {
        const entryChannelDescription = value.description.trim() ; 
        if(entryChannelDescription){
            const descriptionExists = entrychannels.elements.some(entryChannel => entryChannel.description.toLowerCase() === entryChannelDescription.toLowerCase());            
            if(descriptionExists && entryChannelDescription.toLowerCase() !== entrychannels.elements.find(entryChannel => entryChannel.entryChannelId === value.entryChannelId)?.description.toLowerCase()) //La descripción ya existe y es distinta a la actual
                dispatch(openModal({ type: "warning", message:"A descrição inserida já existe."}))
            else{
                const editEntryChannelParams ={
                    param: value.entryChannelId,
                    entryChannelId: value.entryChannelId,
                    body:{        
                        description: entryChannelDescription
                    } 
                }
                dispatch(editEntryChannel(editEntryChannelParams)).then((data) => {
                    if(data.error)
                        dispatch(openModal({ type: "warning", message:data.error.message}))
                    else{
                        getListEntryChannels(mapPageInfo({...entrychannels, ...sortOptions}));
                        closeEditModal()
                    }    
                })
            }
        }else{
           closeEditModal()
        }             
    }

    const handleDeleteClick = (id, closeDeleteModal) => {
        dispatch(deleteEntryChannel({param: id})).then((data) => {
            if(data.error)
                dispatch(openModal({ type: "warning", message:data.error.message}))
            else{
                let updatedPageIndex = entrychannels.pageIndex;

                if (entrychannels.elements.length === 1) {
                    updatedPageIndex = Math.max(0, entrychannels.pageIndex - 1);
                }

                const updatedEntryChannels = {
                    ...entrychannels,
                    pageIndex: updatedPageIndex,
                };

                getListEntryChannels(mapPageInfo({...updatedEntryChannels, ...sortOptions}));
                closeDeleteModal()           
            }
        })  
    }

    function allowDelete(rowData){
        return rowData.data.custom;
    }

    return(
        <div style={{width: "100%"}}>
            <AdminTable
                sectionTitle={"Canais de entrada"} 
                masterTitle={"Canal de entrada"} 
                itemIdField={"entryChannelId"} 
                itemDescriptionField={"description"} 
                loading={loading} 
                getData={getListEntryChannels} 
                dataSource={entrychannels} 
                columnasTabla={columnsEntryChannels} 
                onCreate={handleSaveNewEntryChannelClick}
                onDelete={handleDeleteClick}
                onEdit={handleEditClick} 
                numElements={[10, 20, 30]}
                allowDelete={allowDelete}
                sortField={sortOptions}
                setsortField={setSortOptions}
            />
        </div>
    )
}
export default EntryChannelManagement;